import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { offsetTimezone } from '../../../services/utils';

const MemoMobileColumn = ( { row } ) => {
	return (
		<div style={{
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis'
		}}>
			<span><strong>{ row.name }</strong></span>
			<br />
			<span>{ row.program }</span>
			<br />
			{
				row.createdOn === '0001-01-01T00:00:00'
					? null
					: <span>{ offsetTimezone( row.createdOn, 'date' ) }</span>
			}
		</div>
	);
};

MemoMobileColumn.propTypes = { row: PropTypes.object.isRequired };

export default memo( MemoMobileColumn );
